import { render, staticRenderFns } from "./fulfillment-group.vue?vue&type=template&id=2dc70b10"
import script from "./fulfillment-group.vue?vue&type=script&lang=js"
export * from "./fulfillment-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports